module.exports = __webpack_public_path__ + "img/33.620a2790.jpg";